import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { Tabs, Tab } from 'material-ui/Tabs';
import ZoomIn from 'material-ui/svg-icons/action/zoom-in';
import AttachMoney from 'material-ui/svg-icons/editor/attach-money';
import Visibility from 'material-ui/svg-icons/action/visibility';
import Build from 'material-ui/svg-icons/action/build';
import Badge from 'material-ui/Badge';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';

import Loading from '../Loading';

const CompaniesTable = (props) => {
  return (
    <Table selectable={false}>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Name</TableHeaderColumn>
          <TableHeaderColumn>Actions</TableHeaderColumn>
          <TableHeaderColumn>Since</TableHeaderColumn>
          <TableHeaderColumn>Plan</TableHeaderColumn>
          <TableHeaderColumn>Used mins</TableHeaderColumn>
          <TableHeaderColumn>Status</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.companies.map((company, i) =>
          <TableRow key={i}>
            <TableRowColumn>{company.name}</TableRowColumn>
            <TableRowColumn>
              <span>
                <ZoomIn
                  style={{cursor: 'pointer'}}
                  onClick={() => {props.push(`/company-detail/${company.id}`)}} />
              </span>
              <span>
                <Visibility
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `https://app.brandedbridgeline.com/app/#/users/view-as/${company.id}/`, '_blank'
                  )} />
              </span>
              <span>
                <AttachMoney
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `https://dashboard.stripe.com/customers/${company.customer_id}/`, '_blank'
                  )} />
              </span>
              <span>
                <Build
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `http://` + window.location.hostname + `/bbladmin/accounts/company/${company.id}/`, '_blank'
                  )} />
              </span>
            </TableRowColumn>
            <TableRowColumn>
              <Moment format="YYYY/MM/DD">{company.created}</Moment>
            </TableRowColumn>
            <TableRowColumn>{company.tariff ? company.tariff.name : '-'}</TableRowColumn>
            <TableRowColumn>{company.total_minutes_used}</TableRowColumn>
            <TableRowColumn>{company.status}</TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

const UsersTable = (data) => {
  return (
    <Table selectable={false}>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>First Name</TableHeaderColumn>
          <TableHeaderColumn>Last Name</TableHeaderColumn>
          <TableHeaderColumn>Email</TableHeaderColumn>
          <TableHeaderColumn>Company</TableHeaderColumn>
          <TableHeaderColumn>Actions</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.users.map((user, i) =>
          <TableRow key={i}>
            <TableRowColumn>{user.first_name}</TableRowColumn>
            <TableRowColumn>{user.last_name}</TableRowColumn>
            <TableRowColumn>{user.email}</TableRowColumn>
            <TableRowColumn>-</TableRowColumn>
            <TableRowColumn>
              <span>
                <Build
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `http://` + window.location.hostname + `/bbladmin/auth/user/${user.id}/`, '_blank'
                  )} />
              </span>
            </TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

const NumbersTable = (data) => {
  return (
    <Table selectable={false}>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Owner (Company Name)</TableHeaderColumn>
          <TableHeaderColumn>Title</TableHeaderColumn>
          <TableHeaderColumn>Main Number</TableHeaderColumn>
          <TableHeaderColumn>Actions</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.numbers.map((number, i) =>
          <TableRow key={i}>
            <TableRowColumn>{number.route_to.company.name}</TableRowColumn>
            <TableRowColumn>{number.title}</TableRowColumn>
            <TableRowColumn>{number.number}</TableRowColumn>
            <TableRowColumn>
              <span>
                <Build
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `http://` + window.location.hostname + `/bbladmin/bridges/did/${number.id}/`, '_blank'
                  )} />
              </span>
            </TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

class SearchResults extends Component {
  render() {
    const { data:results, loading } = this.props.results;
    if (Object.keys(results).length === 0 || loading) {
      return (
        <Loading />
      );
    }
    return (
      <Tabs>
        <Tab
          label={<Badge badgeContent={results.companies.length} secondary={true} badgeStyle={{top:4}}>Companies</Badge>}>
          <div>
            <CompaniesTable companies={results.companies} push={this.props.history.push}/>
          </div>
        </Tab>
        <Tab label={<Badge badgeContent={results.users.length} secondary={true} badgeStyle={{top:4}}>Users</Badge>}>
          <div>
            <UsersTable users={results.users} />
          </div>
        </Tab>
        <Tab label={<Badge badgeContent={results.numbers.length} secondary={true} badgeStyle={{top:4}}>Numbers</Badge>}>
          <div>
            <NumbersTable numbers={results.numbers} />
          </div>
        </Tab>
      </Tabs>
    );
  }
}

const mapStateToProps = state => ({ results: state.search });

const enhance = connect(mapStateToProps, null)(SearchResults);

export default withRouter(enhance);



// WEBPACK FOOTER //
// ./src/components/Search/SearchResults.js